import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { Header, Loader } from 'semantic-ui-react';
import { fetchLanguages, fetchDocumentTypes, fetchCertificateReasons, fetchDocumentTemplates, fetchDocumentStatuses } from '../Lookups/util';
import NewRequest from './NewRequest';
import CurrentRequests from './CurrentRequests';
import PreviousRequests from './PreviousRequests';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class StudentsCertificateRequests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            certificateReasons: [],
            documentTypes: [],
            documentTemplates: [],
            languages: [],
            documentStatuses: [],
            studentOrganizationalUnits: [],

            addRequestMode: false,
            previousRequestMode: false,
            sent: false,
            loading: true,
            loadingButton: false,
        };
        this.getStudentDocumentRequests = this.getStudentDocumentRequests.bind(this);
        this.sendDocumentRequest = this.sendDocumentRequest.bind(this);
        this.fetchLanguagesDocumentTypesAndTemplates = this.fetchLanguagesDocumentTypesAndTemplates.bind(this);
        this.handleLoadingButtonChange = this.handleLoadingButtonChange.bind(this);
    }

    handleLoadingButtonChange() {
        this.setState({loadingButton:true});
    }

    componentDidMount() {
        this.fetchLanguagesDocumentTypesAndTemplates();
    }

    fetchLanguagesDocumentTypesAndTemplates() {
        axios.all([fetchLanguages(), fetchDocumentTypes(), fetchCertificateReasons(), fetchDocumentTemplates(), fetchDocumentStatuses(), axios.get('students/organizational-units/')])
            .then(axios.spread((languagesRes, documentTypeRes, certificateReasonRes, documentTemplatesRes, documentStatusRes, studentOrganizationalUnitsRes) => {
                const documentTypes = documentTypeRes.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale)
                        ? el.translations.find(e => e.language === window.$locale).name : el.name : el.name)
                }));
                const certificateReasons = certificateReasonRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale)
                        ? el.translations.find(e => e.language === window.$locale).name : el.name : el.name)
                }));

                this.setState({
                    languages: languagesRes.data,
                    documentTypes,
                    certificateReasons,
                    documentTemplates: documentTemplatesRes.data,
                    documentStatuses: documentStatusRes.data,
                    studentOrganizationalUnits: studentOrganizationalUnitsRes.data,
                });
            }))
            .then(res => { this.getStudentDocumentRequests(); })
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch languages, document types or templates');
            });
    }


    getStudentDocumentRequests() {
        axios.get(`/student-documents/requests/${window.$locale}`)
            .then(res => {
                console.log('documentStatuses', this.state.documentStatuses);

                const data = res.data.map(el => {
                    const status = this.state.documentStatuses.find(e => {
                        if (window.$locale === 'bs') {
                            return e.name === el.documentStatusName;
                        }
                        const translation = e.translations.find(t => t.language === window.$locale);
                        const translatedName = translation ? translation.name : e.name;
                        return translatedName === el.documentStatusName;
                    });

                    return {
                        ...el,
                        date: moment(el.date).format('D. M. YYYY.'),
                        processed: status ? status.processed : undefined,
                        // Bosnian (untranslated) status name, kept as a stable key for UI logic —
                        // el.documentStatusName is already localized text and must not be compared against.
                        documentStatusCategory: status ? status.name : undefined
                    };
                });

                this.setState({ data, loading: false, loadingButton: false });
            })
            .catch(err => {
                this.setState({ error: true, loading: false, loadingButton: false });
                console.log('Failed to fetch results', err);
            });
    }


    sendDocumentRequest() {
        this.getStudentDocumentRequests();
        this.setState({ addRequestMode: false });
    }

    render() {
        // if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        let filteredDocumentTypes = this.state.documentTypes;
        let isEconomyStudent = this.state.studentOrganizationalUnits.some(el => el.abbreviation === "EFSA");
        filteredDocumentTypes = filteredDocumentTypes.filter(el =>
            el.name === 'Statusna potvrda' ||
            el.name === 'Prepis ocjena' && !isEconomyStudent ||
            el.name === 'Prepis ocjena (po godinama studija)' && !isEconomyStudent);

        return (
            <div>
                <Header as="h1"><FormattedMessage id="studentDocuments.requests" /></Header>
                {localStorage.getItem('activeRole').substr(0, 8) === 'Student:' && <div>
                    {/* {this.state.addRequestMode && <NewRequest */}
                    {/*    documentTypes={this.state.documentTypes.filter(el => el.name === 'Statusna potvrda' || el.name === 'Prepis ocjena')} */}
                    {/*    documentTemplates={this.state.documentTemplates} */}
                    {/*    certificateReasons={this.state.certificateReasons} */}
                    {/*    documentLanguages={this.props.documentLanguages} */}
                    {/*    sendDocumentRequest={this.sendDocumentRequest} */}
                    {/*    closeAddRequestMode={() => this.setState({ addRequestMode: false })} */}
                    {/*    activateAddRequest={(addRequestMode) => this.setState({ addRequestMode })} */}
                    {/* />} */}
                    <CurrentRequests
                        data={this.state.data.filter(el => !el.processed)}
                        activateAddRequest={(addRequestMode) => this.setState({ addRequestMode })}
                        cancelRequest={this.getStudentDocumentRequests}
                        loading={this.state.loading}
                        handleLoadingButtonChange={this.handleLoadingButtonChange}
                        loadingButton={this.state.loadingButton}
                        documentTypes={filteredDocumentTypes}
                        documentTemplates={this.state.documentTemplates}
                        certificateReasons={this.state.certificateReasons}
                        documentLanguages={this.props.documentLanguages}
                        sendDocumentRequest={this.sendDocumentRequest}
                        closeAddRequestMode={() => this.setState({ addRequestMode: false })}
                    />

                </div>}
                <PreviousRequests
                    data={this.state.data.filter(el => el.processed)}
                    loading={this.state.loading}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentsCertificateRequest/StudentsCertificateRequests.js